import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { applyMockTheme, listenToMessage } from './service/jiraOPService';

applyMockTheme();
listenToMessage();

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root'),
);
